import { useContext, useMemo } from 'react';

import type { FilterTypeKeysWithJaneGold } from '@jane/bloom/viewModels/productSearchFilters';
import { isProductSearchFilterTypeKey } from '@jane/bloom/viewModels/productSearchFilters';

import { BloomFilterContext } from './provider';

// Mimic Marketplace Filter orders: libs/search/hooks/src/lib/useFormattedProductFilters/useFormattedProductFilters.ts#L267

// Move it up if we want to see it in Featured
const ALL_DISPLAY_FILTER_KEY_SORTING_ORDER: FilterTypeKeysWithJaneGold[] = [
  'jane-gold',
  'categories',
  'brands',
  'lineages',
  'specials',
  'feelings',
  'activities',
  'ratings',
  'potencies',
  'terpenes',
  'prices',
  'weights',
];

export const useBloomFilters = () => {
  const {
    availableFilters,
    displayFilterKeys,
    searchCriteria,
    shouldShowGold,
  } = useContext(BloomFilterContext);

  const selectedCategory = searchCriteria?.selectedCategory;

  const sortedDisplayFilterKeys = useMemo(
    () =>
      displayFilterKeys.sort((a, b) => {
        if (a === 'categories') {
          return -1;
        }
        if (b === 'categories') {
          return 1;
        }
        return 0;
      }),
    [displayFilterKeys]
  );

  const sortedAllDisplayFilterKey = ALL_DISPLAY_FILTER_KEY_SORTING_ORDER.filter(
    (filterKey) => {
      if (filterKey === 'potencies') {
        return !!(
          availableFilters?.thcPotencies || availableFilters?.cbdPotencies
        );
      }

      return availableFilters && isProductSearchFilterTypeKey(filterKey)
        ? !!availableFilters[filterKey]
        : false;
    }
  );

  return {
    availableFilters,
    displayFilterKeys,
    searchCriteria,
    selectedCategory,
    shouldShowGold,
    sortedAllDisplayFilterKey,
    sortedDisplayFilterKeys,
  };
};
